import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Designation, DesignationCreate, DesignationFilter } from '../data/designation';

export function createDesignationService(client: AxiosInstance) {
  return createCrudService<Designation, DesignationCreate, DesignationFilter>(
    client,
    '/master-data/Designation',
    'designationId',
  );
}

export type DesignationService = CrudService<Designation, DesignationCreate, DesignationFilter>;
